import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ReceivedOnDatePicker from "../capture/ReceivingWizard/ReceivedOnDatePicker";

export default function Header({ title, actions, displayReceivedOn, info, isDraft, shipmentStatus, onClose, sticky = false }) {
  const renderStatusChip = () => {
    if (shipmentStatus === 'draft' || isDraft) {
      return (
        <Chip
          size="medium"
          color="warning"
          variant="outlined"
          label="Draft"
          sx={{
            borderRadius: 1,
            "& .MuiChip-label": {
              fontWeight: 500,
              fontSize: 16,
            },
          }}
        />
      );
    }
    
    if (shipmentStatus === 'onsite_inventory') {
      return (
        <Chip
          size="medium"
          color="error"
          variant="outlined"
          label="Onsite Inventory"
          sx={{
            borderRadius: 1,
            "& .MuiChip-label": {
              fontWeight: 500,
              fontSize: 16,
            },
          }}
        />
      );
    }
    
    return null;
  };

  return (
    <Box
      sx={sticky ? {
        position: "sticky",
        top: 0,
        backgroundColor: "white",
        zIndex: 10
      } : {}}
    >
      <Box
        px={2}
        py={1}
        minHeight={64}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          <Typography fontSize={18} fontWeight={500}>
            {title}
          </Typography>
          {actions}
        </Box>
        <Box display="flex" gap={1} alignItems="center">
          {renderStatusChip()}
          {displayReceivedOn ? (
            <ReceivedOnDatePicker />
          ) : typeof info === "string" ? (
            <Typography>{info}</Typography>
          ) : (
            info
          )}
          {onClose && (
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Box>
      <Divider />
    </Box>
  );
}
